import REQUEST_KEY from '@common/constants/requestKeys';
import { useRedirect } from '@common/hooks/useRedirect';
import { GENERAL_EXCEPTION } from '@src/common/constants/exceptions';
import { getRequestState } from '@store/app';
import { useAppSelector } from '@store/hooks';
import { useGetJobNotFoundLink } from '../appPageLinks';

export function useRedirectToJobNotFoundIfError() {
  const loadJobError = useAppSelector(
    getRequestState(REQUEST_KEY.JOB.LOAD)
  ).error;
  const { redirect } = useRedirect();
  const jobNotFoundLink = useGetJobNotFoundLink();

  if (loadJobError?.message === GENERAL_EXCEPTION.NOT_FOUND) {
    redirect(jobNotFoundLink)();
  }
}
